import type { Site } from '@hotjar/site';
import { useCurrentSiteProp } from '@hotjar/site';
import type { UseQueryResult } from 'react-query';
import type { SiteAccount } from '../api/site-account';

const selector = (site: Site | undefined): SiteAccount | undefined => site?.account;

/**
 * This hook returns the account that appears on the site object we get from the `/api/v1/users/<user_id>/resources`
 * endpoint.This account object is always present but contains less data than the account object attached to the user
 * we get from the `/api/v2/users/me` endpoint. If you need billing information, rather use the `useOwnedAccount`
 * hook.
 */
export function useCurrentSiteAccount(): UseQueryResult<SiteAccount | undefined> {
  return useCurrentSiteProp(selector);
}
